export default __webpack_public_path__ + "static/media/Francesco-auf-Roller.b17c33de.png";